module.exports = __webpack_public_path__ + "img/back2.4a5fec1b.gif";